import React, { useRef } from 'react';
import emailjs from 'emailjs-com';
const Form = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_x8yc42f', 'template_ew5m4gn', form.current, 'user_FxhtbYfhC6vL8E4IkIgSf')
            .then((result) => {
                console.log(result.text);
                e.target.reset();

            }, (error) => {
                console.log(error.text);
                alert('there was an error');
                e.target.reset();
            });
    };
    return (
        <div className="mt-5 pb-4 md:mt-0 md:col-span-2 w-10/12 lg:w-10/12 mx-auto  ">
            <form ref={form} onSubmit={sendEmail}>
                <div className="shadow overflow-hidden sm:rounded-md">
                    <div className="px-4 py-5 bg-transparent sm:p-6">
                        <div className="grid grid-cols-6 gap-6 text-white">
                            <div className="col-span-6 sm:col-span-3">
                                <label htmlFor="first-name" className="block text-sm font-medium text-white">
                                    First name
                                </label>
                                <input
                                    type="text"
                                    name="first-name"
                                    id="first-name"
                                    autoComplete="given-name"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 
                                    py-2 px-1 bg-gray-custom
                                    block w-full shadow-sm sm:text-sm border-gray-400 border rounded-md"
                                />
                            </div>

                            <div className="col-span-6 sm:col-span-3">
                                <label htmlFor="last-name" className="block text-sm font-medium text-white">
                                    Last name
                                </label>
                                <input
                                    type="text"
                                    name="last-name"
                                    id="last-name"
                                    autoComplete="family-name"
                                    className="mt-1 
                                    py-2 px-1 bg-gray-custom
                                     focus:ring-indigo-500 focus:border-indigo-500 
                                     block w-full shadow-sm sm:text-sm border-gray-400 border rounded-md"
                                />
                            </div>

                            <div className="col-span-6 sm:col-span-4 ">
                                <label htmlFor="email-address" className="block text-sm font-medium text-white">
                                    Email address
                                </label>
                                <input
                                    type="text"
                                    name="email-address"
                                    id="email-address"
                                    autoComplete="email"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 
                                    py-2 px-1 bg-gray-custom
                                    block w-full shadow-sm sm:text-sm border-gray-400 border rounded-md"
                                />
                            </div>

                            <div className="col-span-6">
                                <label htmlFor="message" className="block text-sm font-medium text-white">
                                    Short Message for Me
                                </label>
                                <textArea
                                    type="text"
                                    name="message"
                                    id="message"
                                    autoComplete="message"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 
                                    py-2 px-1 bg-gray-custom
                                    block w-full shadow-sm sm:text-sm border-gray-400 border rounded-md"
                                />
                            </div>

                        </div>
                    </div>
                    <div className="px-4 py-3 bg-transparent text-left sm:px-6">
                        <button
                            type="submit"
                            className="inline-flex justify-center py-2 px-4 
                            border border-white 
                            shadow-sm text-sm font-medium rounded-md text-white hover:text-pink-700 
                            bg-pink-800 hover:bg-white font-concertone
                            "
                        >
                            Send
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default Form;